export const STATSIG_SEARCH_LAYER = 'search_page_experiments';

export enum SearchDistanceFiltersExperimentVariants {
    CONTROL = 'control',
}

export const SEARCH_DISTANCE_FILTERS_EXPERIMENT = {
    layer: STATSIG_SEARCH_LAYER,
    parameter: 'search_fe_distance_filters',
    variants: SearchDistanceFiltersExperimentVariants,
};
